import { Stack } from '@mui/joy';
import { localDateToString } from '@/utils/datetime';
import { WeekdaySquare } from './WeekdaySquare';

export function WeekdaySelector({ days, selectedDate, onSelectDate }) {
  const today = new Date();
  const todayString = localDateToString(today);

  return (
    <Stack
      direction="row"
      gap={'5px'}
      sx={{ px: 0, py: 0 }}
    >
      {days.map((day) => {
        const dateString = localDateToString(day.date);
        const isToday = dateString === todayString;
        const isSelected = dateString === selectedDate;

        return (
          <WeekdaySquare
            key={dateString}
            date={day.date}
            mealsAssigned={day.mealsAssigned}
            isToday={isToday}
            isSelected={isSelected}
            onClick={() => onSelectDate(day.date)}
          />
        );
      })}
    </Stack>
  );
}

